export default "__VITE_ASSET__CotXv1pR__"